import { SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import { FC, PropsWithChildren, ComponentProps } from 'react';
import Item from './Item';

interface ListComposition {
  Item: FC<ComponentProps<typeof Item>>;
}

interface Props extends PropsWithChildren {
  /**
   * classname 을 지정합니다.
   */
  classname?: string;
  /**
   * custom 스타일 css 를 정의합니다.
   */
  css?: SerializedStyles;
}

/**
 * 공통 List 컴포넌트
 * @component
 */
const List: FC<Props> & ListComposition = ({ children, classname, css: custom_css }) => {
  return (
    <SC.Container className={classname} css={custom_css}>
      {children}
    </SC.Container>
  );
};

List.Item = Item;
export default List;

const SC = {
  Container: styled.ul`
    width: 100%;
  `,
};
